import type { EntryPoint } from '@/apilib';
import { EditorAPIKey } from '@/apis';
import { createAdvancedMenu } from './createAdvancedMenu';
import { AdvancedMenuApiKey } from '../publicApiKey';

export const AdvancedMenuEntryPoint: EntryPoint = {
  name: 'AdvancedMenuApi',
  declareAPIs: () => [AdvancedMenuApiKey],
  getDependencyAPIs: () => [EditorAPIKey],
  attach(shell) {
    shell.contributeAPI(AdvancedMenuApiKey, () => createAdvancedMenu(shell));
  },
};
